import React from "react";
import styled from "styled-components";
import CancelIcon from "@material-ui/icons/Cancel";
import { CircleButton } from "@sonder/ui/source/styled/fragments/CircleButton";
import { ValidationException } from "@sonder/ui/source/styled/fragments/ValidationException";
import { colors, zIndex } from "@sonder/ui/source/styled/theme";
import { clearValidationException } from "tasks/actions";
import { useStore } from "tasks/store";

const StyledValidationExceptionHeader = styled.div`
  background-color: ${colors.redD};
  left: 0;
  padding: 0.7rem 1rem;
  position: fixed;
  top: 0;
  right: 0;
  z-index: ${zIndex.validationException};

  ${ValidationException} {
    align-items: center;
    color: ${colors.white};
    display: flex;
    justify-content: space-between;
  }
`;

export const ValidationExceptionHeader = () => {
  const {
    dispatch,
    state: { validationExceptions },
  } = useStore();

  const hasValidationExceptions = validationExceptions.length > 0;

  if (!hasValidationExceptions) {
    return null;
  }

  return (
    <StyledValidationExceptionHeader data-testid="validation-exception-header">
      {validationExceptions.map(exception => (
        <ValidationException key={exception}>
          <span>{exception}</span>
          <CircleButton
            backgroundVariant="dark"
            onClick={() => {
              dispatch(clearValidationException(exception));
            }}
          >
            <CancelIcon />
          </CircleButton>
        </ValidationException>
      ))}
    </StyledValidationExceptionHeader>
  );
};
